import { NUMBER_OF_CARS_PER_PAGE } from './constants';

export const getNumberOfCarsPerPage = (cars, start) => {
  const end = start + NUMBER_OF_CARS_PER_PAGE;
  return end < cars.length ? end : cars.length;
};
// unused. Delete???
export const getCarsPageState = (cars, start) => {
  const end = getNumberOfCarsPerPage(cars, start);
  return cars.slice(start, end);
};

export const setSession = (item, state) => {
  sessionStorage.setItem(item, JSON.stringify(state));
};

export const saveLocal = (item, state) => {
  const savedState = state.Model ? { ...state } : { ...state, Model: 'None' };
  localStorage.setItem(item, JSON.stringify(savedState));
};

export const loadLocal = (item) => {
  const savedItem = localStorage.getItem(item);
  return savedItem ? JSON.parse(savedItem) : undefined;
};

export const getSession = (item) => {
  const savedItem = sessionStorage.getItem(item);
  return savedItem ? JSON.parse(savedItem) : undefined;
};

export const getTranslatedOptions = (options) =>
  options.map((el) => ({ value: el, label: startup.dictionary[el] }));

export const scrollPageToTop = () => {
  const scrollTarget = document.querySelector('.b-goods-group');
  const topOffset = document.querySelector('.header-main').offsetHeight;
  const elementPosition = scrollTarget.getBoundingClientRect().top;
  const offsetPosition = elementPosition - topOffset - 150;
  window.scrollBy({
    top: offsetPosition,
    behavior: 'smooth',
  });
};

export const loanCalculator = (amount, leaseTermInMonthes) => {
  const apr = 8;
  const leaseMonthPercent = apr / 1200;
  const x = (1 + leaseMonthPercent) ** leaseTermInMonthes;
  const monthPayment = (amount * x * leaseMonthPercent) / (x - 1);
  return Math.round(monthPayment * 100) / 100;
};

export const imageReader = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const imageResizer = async (file) => {
  const width = 1200;
  const content = await imageReader(file);
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = content;
    image.onload = () => {
      const elem = document.createElement('canvas');
      elem.width = width;
      const scaleFactor = width / image.width;
      elem.height = image.height * scaleFactor;
      const ctx = elem.getContext('2d');
      ctx.drawImage(image, 0, 0, elem.width, elem.height);
      ctx.canvas.toBlob(
        (blob) => {
          const resizedFile = new File([blob], file.name, {
            type: 'image/jpeg',
            lastModified: Date.now(),
          });
          elem.remove();
          resolve(resizedFile);
        },
        'image/jpeg',
        0.8
      );
    };
    image.onerror = reject;
  });
};

export const getShortImageUrl = (url) => url.slice(url.lastIndexOf('/') + 1);

export const getDiscountPrice = (price) => price; // - price * .1;
